var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-width"},[(!!_vm.label)?_c('div',{staticClass:"text-body-2 mb-1"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('v-file-input',{attrs:{"counter":"","multiple":"","show-size":"","small-chips":"","truncate-length":"15"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }